module.exports = __webpack_public_path__ + "img/EH.8c444a4a.png";